import Vue from "vue";
import VueNumeric from "vue-numeric";

Vue.use(VueNumeric);
